<template lang="pug">
div
  Form(:data="feedbackPoint", :isSubmitting="isSubmitting", @submit="update")
</template>

<script>
import { onMounted } from '@vue/composition-api'
import Form from '../shared/Form.vue'
import useFeedbackPointEdit from './useFeedbackPointEdit'

export default {
  components: {
    Form,
  },
  setup() {
    const { show, update, feedbackPoint, isSubmitting } = useFeedbackPointEdit()

    onMounted(show)

    return {
      feedbackPoint,
      update,
      isSubmitting,
    }
  },
}
</script>
